import {SocialAssetType, SocialPlatform} from '../../modules/social/social.types';
import {CLIssueName} from '../../modules/issues/issues.types';
import {NotificationSeverityName} from '../../modules/notifications/notifications.types';
import createIconsObj from './utils/createIconsObj';
import {StorageType} from '../../modules/storages/storages.types';
import {DashboardWidgetSize, DashboardWidgetType} from '../../modules/dashboards/dashboards.types';
import {MetricsChartType, MetricValue} from '../../modules/analytics/analytics.types';
import {FacebookPlacementType} from '../../modules/externalAds/externalAds.types';
import {MovieLayerType} from '../../modules/movie/movie.enums';

export const iconsObjData = {
  missingImage: '/no-thumbnail-icon.svg',
  automate: '/mask-icon-automate.svg',
  edit: '/mask-icon-edit.svg',
  edit2: '/edit-icon-new.svg',
  edit3: '/mask-icon-edit-3.svg',
  replace: '/replace_icon.svg',
  replaceArrows: '/replace-arrows.svg',
  clear: '/Icon-Clear.svg',
  search: '/icon-search.svg',
  magnify: '/mask-icon-preview.svg',
  addFile: '/icon-add-file.svg',
  warning: '/mask-icon-warning.svg',
  closeX: '/close-icon-x.svg',
  trash: '/mask-icon-trash-2.svg',
  trashBold: '/trash-bold.svg',
  trashWithWhiteBackground: '/trash_2_icon.svg',
  sendArrow: '/mask-icon-shaped-send-arrow.svg',
  globe: '/mask-icon-globe.svg',
  trashWhite: '/mask-icon-trash-white-background.svg',
  download: '/mask-icon-download.svg',
  downloadV2: '/mask-icon-download-v2.svg',
  createFolder: '/dam/mask-icon-add-folder.svg',
  uploadFile: '/dam/mask-icon-upload-file.svg',
  uploadFolder: '/dam/mask-icon-upload-folder.svg',
  downloadThick: '/mask-icon-download-thick-2.svg',
  expand: '/mask-icon-expand.svg',
  expandV3: '/mask-icon-expand-v3.svg',
  revert: '/mask-icon-revert.svg',
  share: '/mask-icon-share.svg',
  shareV2: '/mask-icon-share-v2.svg',
  shareOwner: '/mask-icon-share-owner.svg',
  shareCollaborator: '/mask-icon-share-collaborator.svg',
  plus: '/mask-icon-plus-sign.svg',
  plusV2: '/mask-icon-plus-v2.svg',
  fullPlus: '/full-plus-icon.svg',
  minus: '/mask-icon-minus.svg',
  rotate: '/rotate_cursor_icon.svg',
  plusCircleFilled: '/mask-icon-plus-circle-filled.svg',
  minusCircleFilled: '/mask-icon-minus-circle-filled.svg',
  blueCircledMinus: '/blue-circled-minus.svg',
  blueCircledPlus: '/blue-circled-plus.svg',
  circledPlus: '/circled-plus-icon.svg',
  play: '/mask-icon-play-bold.svg',
  playFull: '/full-play-icon.svg',
  playCircle: '/mask-icon-play-circle-2.svg',
  pause: '/mask-icon-pause-bold.svg',
  checkboxV: '/mask-icon-v.svg',
  link: '/mask-icon-link.svg',
  linkV2: '/mask-icon-link-v2.svg',
  linkHorizontal: '/mask-icon-link-horizontal.svg',
  refresh: '/mask-icon-refresh.svg',
  refreshBold: '/refresh-bold-icon.svg',
  clinchLogo: '/clinch-icon.svg',
  clinchFullLogo: '/clinch-new-logo.svg',
  clinchLogoWhite: '/clinch-icon-white.svg',
  clinchLogoWhiteBG: '/clinch-logo-white-bg.svg',
  caretDown: '/icon-caret-down.svg',
  caretRight: '/icon-caret-right.svg',
  fullCaretDown: '/full-caret-down-icon.svg',
  spinner: '/mask-icon-loading.svg',
  success: '/mask-icon-v.svg',
  infoOutline: '/mask-icon-info-outline.svg',
  infoOutlineIcon: '/mask-icon-info-outline-new.svg',
  settingsOutline: '/mask-icon-settings-outline.svg',
  save: '/mask-icon-save.svg',
  file: '/mask-icon-file.svg',
  folder: '/mask-icon-folder.svg',
  folderColored: '/folder-icon.svg',
  previewFill: '/mask-icon-view.svg',
  preview: '/mask-icon-preview-mode.svg',
  noPreview: '/mask-icon-no-preview.svg',
  export: '/mask-icon-export.svg',
  duplicate: '/mask-icon-duplicate.svg',
  settings: '/mask-icon-settings.svg',
  settingsFill: '/mask-icon-settings-fill.svg',
  settingsMenu: '/settings-icon-2.svg',
  settingsMenuFull: '/settings-icon-2-full.svg',
  integration: '/mask-icon-integration-4.svg',
  general: '/mask-icon-general-2.svg',
  error: '/mask-icon-fail.svg',
  lock: '/mask-icon-locker.svg',
  lockOutline: '/mask-icon-lock-outline.svg',
  clock: '/mask-icon-clock.svg',
  dsp: '/mask-icon-dsp.svg',
  user: '/mask-icon-user.svg',
  userSmall: '/mask-icon-user-4.svg',
  location: '/mask-icon-location.svg',
  pin: '/icon-pin-enabled.svg',
  unPin: '/icon-pin-disabled.svg',
  hamburger: '/hamburger_menu_icon.svg',
  video: '/icon-video.svg',
  dragArea: '/drag-area-icon.svg',
  help: '/mask-icon-help.svg',
  helpFlat: '/mask-icon-help-book.svg',
  productCount: '/icon-cube.svg',
  arrowUp: '/arrow_up.svg',
  doubleArrowRight: '/mask-icon-double-arrow.svg',
  doubleArrowBold: '/double-arrow-bold.svg',
  doubleArrowUp: '/mask-icon-double-arrow-up.svg',
  arrowUpRight: '/mask-icon-arrow-up-right.svg',
  arrowUpShort: '/arrow-up-short-3.svg',
  arrowRight: '/mask-icon-arrow-right.svg',
  arrowShort: '/mask_icon_arrow_short.svg',
  arrowSolid: '/mask-icon-arrow-solid.svg',
  arrowBold: '/arrow-bold.svg',
  closeDetails: '/mask-icon-close-details.svg',
  openDetails: '/mask-icon-open-details.svg',
  adTag: '/mask-icon-ad-tag-outline.svg',
  filter: '/analytics/mask-icon-filter.svg',
  filterBold: '/mask-icon-filter-bold.svg',
  flightControl: '/flight-control-icon.svg',
  noteBaloon: '/note-baloon-mask-icon.svg',
  noteBaloonOutline: '/note-baloon-outline-icon.svg',
  commentBaloonMask: '/mask-icon-comment-baloon.svg',
  addComment: '/mask-icon-add-comment.svg',
  addCommentNew: '/mask-icon-add-comment-v2.svg',
  scaleButton: '/scale-button.svg',
  fitScaleButton: '/mask-icon-fit-scale.svg',
  arrowRightEnd: '/arrow-right-end-icon.svg',
  publisher: '/publisher-icon.svg',
  videoCamera: '/video-camera-icon-1.svg',
  autoIcon: '/auto-schedule-icon.svg',
  externalLink: '/mask-icon-external-link.svg',
  diary: '/mask-icon-diary.svg',
  wrench: '/mask-icon-wrench.svg',
  funnel: '/mask-icon-funnel.svg',
  collapse: '/collapse-icon.svg',
  collapseClosed: '/mask-icon-collapse-t-off.svg',
  collapseOpened: '/mask-icon-collapse-t-on.svg',
  reset: '/reset-bold-icon.svg',
  connectedLine: '/connected-line-icon.svg',
  approveIcon: '/approve-icon.svg',
  cancelIcon: '/cancel-icon.svg',
  autoArrangeShadowed: '/auto-arrange-shadowed-icon.svg',
  fitToScreenShadowed: '/fit-to-screen-shadowed-icon.svg',
  revertShadowed: '/revert-shadowed-icon.svg',
  collapseShadowed: '/collapse-shadowed-icon.svg',
  fullScaleShadowed: '/full-scale-shadowed-icon.svg',
  expandAllOutputs: '/expand-all-node-output-connectors.svg',
  checkFill: '/mask-icon-check-fill.svg',
  checkOutline: '/mask-icon-check-outline.svg',
  checkSolid: '/mask-icon-check-solid.svg',
  xCircleFill: '/mask-icon-x-circle-filled-2.svg',
  xCircleOutline: '/mask-icon-x-circle-outlined.svg',
  noResults: '/mask-icon-no-result.svg',
  dropFiles: '/mask-icon-drop-file.svg',
  spiral: '/mask-icon-spiral.svg',
  stars: '/release-notes-stars-icon.svg',
  addEditCell: '/add-edit-cell-icon.svg',
  addEditHoveredCell: '/add-edit-hovered-cell-icon.svg',
  miniMap: '/decisionTree/minimap-icon.svg',
  miniMapSelected: '/decisionTree/minimap-selected-icon.svg',
  magnet: '/mask-icon-magnet.svg',
  userProfile: '/user-profile-icon.svg',
  invite: '/invite-icon.svg',
  apiDocs: '/mask-icon-api-doc.svg',
  historyLinkOutline: '/mask-icon-history-link-outline.svg',
  dragHandle: '/mask-icon-drag-handle.svg',
  imagePlaceholder: '/mask-icon-image-placehoder.svg',
  deprecated: '/mask-icon-deprecated.svg',
  instagramReels: '/instagram-reels-icons.svg',
  facebookReels: '/facebook-reels-icons.svg',
  camera: '/camera-mask-icon.svg',
  fileError: '/file-error-icon.svg',
  imageIcon: '/image-ad-icon.svg',
  expandV4: '/expand-v4-icon.svg',
  circledCopyLink: '/share-link-icon.svg',
  verifiedBadge: '/verified-badge-icon.svg',
  sample: '/mask-icon-sample.svg',
  calendar: '/mask-icon-calendar.svg',
  stethoscope: '/mask-icon-stethoscope.svg',
  eyedropper: '/eyedroper-color-picker.svg',
  weight: '/weight.svg',
  verticalReplaceArrows: '/vertical-replace-arrows.svg',
  vectorUp: '/vector-up.svg',
  vectorDown: '/vector-down.svg',

  metricsPage: {
    charts: {
      [MetricsChartType.Line]: '/metricsPage/charts/line.svg',
      [MetricsChartType.Area]: '/metricsPage/charts/area-line.svg',
      [MetricsChartType.Bar]: '/metricsPage/charts/bar.svg',
      [MetricsChartType.HorizontalBar]: '/metricsPage/charts/horizontal-bar.svg',
      [MetricsChartType.PieChart]: '/metricsPage/charts/pie.svg',
    },
  },
  dashboard: {
    addWidget: '/dashboard/add-widget-mask-icon.svg',
    editWidget: '/dashboard/widgets/edit-icon.svg',
    more: '/dashboard/widgets/more-icon.svg',
    menu: '/dashboard/widgets/menu-icon.svg',
    metrics: {
      [MetricValue.Impressions]: '/dashboard/metrics/impressions-icon.svg',
      [MetricValue.Clicks]: '/dashboard/metrics/clicks-icon.svg',
      [MetricValue.Engagements]: '/dashboard/metrics/engagements-icon.svg',
      [MetricValue.Conversions]: '/dashboard/metrics/conversions-icon.svg',
      [MetricValue.ClickThroughConversion]: '/dashboard/metrics/ctc-icon.svg',
      [MetricValue.ViewThroughConversions]: '/dashboard/metrics/vtc-icon.svg',
      [MetricValue.ConversionRate]: '/dashboard/metrics/cr-icon.svg',
      [MetricValue.Sales]: '/dashboard/metrics/sales-icon.svg',
      [MetricValue.Cost]: '/dashboard/metrics/cost-icon-2.svg',
      [MetricValue.Roas]: '/dashboard/metrics/roas-icon-2.svg',
      [MetricValue.CPC]: '/dashboard/metrics/cpc-icon.svg',
      [MetricValue.CPA]: '/dashboard/metrics/cpa-icon-2.svg',
      [MetricValue.ClickThroughRate]: '/dashboard/metrics/ctr-icon.svg',
    },
    widgets: {
      layout: {
        [DashboardWidgetSize.WIDTH_1_HEIGHT_1]: {
          default: '/dashboard/widgets/layout/size-1-1-new.svg',
          active: '/dashboard/widgets/layout/size-1-1-active-new.svg',
        },
        [DashboardWidgetSize.WIDTH_1_HEIGHT_2]: {
          default: '/dashboard/widgets/layout/size-1-2-new.svg',
          active: '/dashboard/widgets/layout/size-1-2-active-new.svg',
        },
        [DashboardWidgetSize.WIDTH_2_HEIGHT_2]: {
          default: '/dashboard/widgets/layout/size-2-2.svg',
          active: '/dashboard/widgets/layout/size-2-2-active.svg',
        },
        [DashboardWidgetSize.WIDTH_2_HEIGHT_4]: {
          default: '/dashboard/widgets/layout/size-2-4.svg',
          active: '/dashboard/widgets/layout/size-2-4-active.svg',
        },
        [DashboardWidgetSize.WIDTH_3_HEIGHT_2]: {
          default: '/dashboard/widgets/layout/size-3-2.svg',
          active: '/dashboard/widgets/layout/size-3-2-active.svg',
        },
        [DashboardWidgetSize.WIDTH_3_HEIGHT_4]: {
          default: '/dashboard/widgets/layout/size-3-4.svg',
          active: '/dashboard/widgets/layout/size-3-4-active.svg',
        },
        [DashboardWidgetSize.WIDTH_6_HEIGHT_2]: {
          default: '/dashboard/widgets/layout/size-6-2.svg',
          active: '/dashboard/widgets/layout/size-6-2-active.svg',
        },
        [DashboardWidgetSize.WIDTH_6_HEIGHT_4]: {
          default: '/dashboard/widgets/layout/size-6-4.svg',
          active: '/dashboard/widgets/layout/size-6-4-active.svg',
        },
      },
      type: {
        [DashboardWidgetType.PIE]: {
          default: '/dashboard/widgets/type/pie.svg',
          active: '/dashboard/widgets/type/pie-active.svg',
        },
        [DashboardWidgetType.LINE_AREA_CHART]: {
          default: '/dashboard/widgets/type/line.svg',
          active: '/dashboard/widgets/type/line-active.svg',
        },
        [DashboardWidgetType.BAR]: {
          default: '/dashboard/widgets/type/bar.svg',
          active: '/dashboard/widgets/type/bar-active.svg',
        },
        [DashboardWidgetType.HORIZONTAL_BAR]: {
          default: '/dashboard/widgets/type/horizontal-bar.svg',
          active: '/dashboard/widgets/type/horizontal-bar-active.svg',
        },
        [DashboardWidgetType.MULTI_TABLE]: {
          default: '/dashboard/widgets/type/table.svg',
          active: '/dashboard/widgets/type/table-active.svg',
        },
        [DashboardWidgetType.MAP]: {
          default: '/dashboard/widgets/type/map.svg',
          active: '/dashboard/widgets/type/map-active.svg',
        },
        [DashboardWidgetType.CARD]: {
          default: '/dashboard/widgets/type/card.svg',
          active: '/dashboard/widgets/type/card-active.svg',
        },
      },
    },
  },

  imageEditor: {
    erase: '/image-editor/mask-icon-erase.svg',
    regenerateOutpaint: '/image-editor/mask-icon-regenerate-outpaint.svg',
    colorPickerMasked: '/image-editor/mask-icon-color-picker.svg',
    colorPicker: '/image-editor/color-picker-icon.svg',
    applyPreview: '/image-editor/mask-icon-apply-preview-2.svg',
    brush: '/image-editor/mask-icon-brush.svg',
    fill: '/image-editor/mask-icon-fill.svg',
    outpaint: '/image-editor/outpaint-icon-2.svg',
    removeBG: '/image-editor/remove-background-icon-2.svg',
    replaceBG: '/image-editor/replace-bg-icon-2.svg',
    noText: '/image-editor/no-text-icon.svg',
    starIcon: '/image-editor-v2/star-icon.svg',
  },

  issues: {
    [CLIssueName.Error]: '/error-alert-icon.svg',
    [CLIssueName.Warning]: '/warning-alert-icon.svg',
    [CLIssueName.Info]: '/issue-information-icon.svg',
    [CLIssueName.Success]: '/issue-success-icon.svg',
  },

  issuesCenter: {
    [CLIssueName.Error]: '/IssuesCenter/error.svg',
    [CLIssueName.Warning]: '/IssuesCenter/warning.svg',
    [CLIssueName.Info]: '/IssuesCenter/info.svg',
    [CLIssueName.Success]: '/issue-success-icon.svg',
  },

  notificationCenter: {
    menuIcon: '/NotificationCenter/notification-center-icon.svg',
    dismiss: '/NotificationCenter/mask-icon-dismiss.svg',
    resolve: '/NotificationCenter/mask-icon-resolve.svg',
    settings: '/NotificationCenter/mask-icon-notifications-settings.svg',
    emptyComment: '/NotificationCenter/icon-no-comment.svg',
    withComment: '/NotificationCenter/icon-comment.svg',
    trendGraph: '/NotificationCenter/mask-icon-notifications-trend-graph.svg',
    [NotificationSeverityName.Error]: '/NotificationCenter/notification-error-icon.svg',
    [NotificationSeverityName.Warning]: '/NotificationCenter/notification-warning-icon.svg',
    [NotificationSeverityName.Info]: '/NotificationCenter/notification-info-icon.svg',
  },

  map: {
    pin: '/map/mask-icon-map-pin.svg',
    selectedPin: '/map/mask-icon-map-pin-selected.svg',
  },

  premiumServices: {
    sun: '/premiumServices/sun.svg',
    dribble: '/premiumServices/dribble.svg',
    advancedTracking: '/premiumServices/advanced-tracking.svg',
    content: '/premiumServices/content.svg',
  },

  socialPlatformLogos: {
    [SocialPlatform.TikTok]: '/externalPlatforms/tiktok-icon.svg',
    [SocialPlatform.Facebook]: '/externalPlatforms/facebook-icon.svg',
    [SocialPlatform.Snapchat]: '/externalPlatforms/snapchat-icon.svg',
    [SocialPlatform.LinkedIn]: '/externalPlatforms/linkedin-icon.svg',
    [SocialPlatform.Youtube]: '/externalPlatforms/youtube-icon.svg',
    [SocialPlatform.GoogleAds]: '/externalPlatforms/google-ads-icon.svg',
    [SocialPlatform.MockSocial]: '/externalPlatforms/mock.svg',
    [SocialPlatform.Pinterest]: '/externalPlatforms/pinterest-icon.svg',
    [SocialPlatform.TheTradeDesk]: '/externalPlatforms/trade-desk-icon.svg',
    [SocialPlatform.DoubleVerify]: '/externalPlatforms/double-verify-icon.svg',
    [SocialPlatform.Foursquare]: '/externalPlatforms/foursquare-icon.svg',
    [SocialPlatform.DV360]: '/externalPlatforms/dv-360-icon.svg',
    [SocialPlatform.Neustar]: '/externalPlatforms/neustar-icon.svg',
    [SocialPlatform.IAS]: '/externalPlatforms/IAS-icon.svg',
    [SocialPlatform.Merkury]: '/externalPlatforms/mercury-logo.svg',
    [SocialPlatform.LiveRamp]: '/externalPlatforms/liveramp-logo.svg',
    [SocialPlatform.AmazonAds]: '/externalPlatforms/amazon-ads-icon.svg',
    [StorageType.S3AwsBucket]: '/externalPlatforms/amazon-s3-icon.svg',
    [StorageType.SFTP]: '/externalPlatforms/sftp-icon.svg',
    [StorageType.Azure]: '/externalPlatforms/azure-icon.svg',
    [StorageType.GCP]: '/externalPlatforms/gcp-icon.svg',
    foursquareMask: '/externalPlatforms/foursquare-mask-icon.svg',
    iasMask: '/externalPlatforms/ias-mask-icon.svg',
    neuStarMask: '/externalPlatforms/neustar-icon.svg',
    dataSources: '/externalPlatforms/data-sources.svg',
    defaultPublisher: '/externalPlatforms/default-publisher-icon.svg',
    audiencesMask: '/externalPlatforms/audiences-icon-2.svg',
    liveRampMask: '/externalPlatforms/liveramp.svg',

    integrations: {
      [SocialAssetType.TikTok]: '/externalPlatforms/integrations/tiktok.svg',
      [SocialAssetType.Facebook]: '/externalPlatforms/integrations/facebook.svg',
      [SocialAssetType.Youtube]: '/externalPlatforms/integrations/youtube.svg',
      [SocialAssetType.Snapchat]: '/externalPlatforms/integrations/snapchat-new.svg',
      [SocialAssetType.LinkedIn]: '/externalPlatforms/integrations/linkedIn.svg',
      [SocialAssetType.GoogleAds]: '/externalPlatforms/integrations/google-ads.svg',
      [SocialAssetType.TheTradeDesk]: '/externalPlatforms/integrations/the-trade-desk.svg',
      [SocialAssetType.DoubleVerify]: '/externalPlatforms/integrations/double-verify.svg',
      [SocialAssetType.Foursquare]: '/externalPlatforms/integrations/foursquare.svg',
      [SocialAssetType.Neustar]: '/externalPlatforms/integrations/neustar.svg',
      [SocialAssetType.IAS]: '/externalPlatforms/integrations/ias.svg',
      [SocialAssetType.Merkury]: '/externalPlatforms/integrations/merkury-new.svg',
      [SocialAssetType.DV360]: '/externalPlatforms/integrations/dv360.svg',
      [SocialAssetType.LiveRamp]: '/externalPlatforms/integrations/liveramp.svg',
      [SocialAssetType.AmazonAds]: '/externalPlatforms/integrations/amazon-ads.svg',
      [SocialAssetType.MockSocial]: '/externalPlatforms/integrations/mock-social.svg',
    },
  },

  mediaWizard: {
    creativeSelection: {
      base: '/BatchMediaWizard/creative-style-icon.svg',
      active: '/BatchMediaWizard/creative-style-icon-selected.svg',
    },
    formatSelection: {
      base: '/BatchMediaWizard/format-icon.svg',
      active: '/BatchMediaWizard/format-icon-selected.svg',
    },
    productSelection: {
      base: '/BatchMediaWizard/product-icon.svg',
      active: '/BatchMediaWizard/product-icon-selected.svg',
    },
    locationSelection: {
      base: '/BatchMediaWizard/location-icon.svg',
      active: '/BatchMediaWizard/location-icon-selected.svg',
    },
    summary: {
      base: '/BatchMediaWizard/summary-icon.svg',
      active: '/BatchMediaWizard/summary-icon-selected.svg',
    },
    variations: {
      base: '/BatchMediaWizard/variations-icon.svg',
      active: '/BatchMediaWizard/variations-icon.svg',
    },
    success: '/BatchMediaWizard/success-icon.svg',
    doubleArrow: '/BatchMediaWizard/mask-icon-double-arrow.svg',
  },
  menus: {
    verticalEllipsis: '/menus/mask-icon-vertical-ellipsis.svg',
    verticalEllipsisNew: '/menus/mask-icon-vertical-ellipsis-new.svg',
    bars: '/menus/mask-icon-bars.svg',
    dropDownArrow: '/menus/mask-icon-dropdown-arrow.svg',
    verticalEllipsisNarrow: '/menus/vertical-dots-narrow-icon.svg',
  },
  toggle: {
    container: '/toggleSwitch/mask-icon-toggle-container.svg',
    circle: '/toggleSwitch/mask-icon-toggle-circle.svg',
  },
  adAccountProfile: {
    canceledIcon: '/adAccountProfile/canceled-icon.svg',
    successIcon: '/adAccountProfile/success-icon.svg',
    trashCanIcon: '/adAccountProfile/trash-can-icon.svg',
  },
  decisionTree: {
    campaign: '/weighted-menu-icon.svg',
    condition: '/condition-menu-icon.svg',
    weighted: '/weighted-menu-icon.svg',
    distribution: '/distribution-menu-icon-1.svg',
    products: '/product-menu-icon2.svg',
    store: '/location-menu-icon.svg',
    contentFeed: '/decisionTree/content-feed-menu-icon.svg',
    creative_optimization: '/creative-opt-menu-icon.svg',
    products_optimization: '/product-opt-menu-icon.svg',
    schedule: '/schedule-menu-icon.svg',
    sequencing: '/sequencing-menu-icon.svg',
    creative: '/creative-menu-icon.svg',
    emptyCreative: '/mask-icon-empty-creative.svg',
    fallbackCreative: '/fallback-creative-menu-icon.svg',
    zoomToFit: '/mask-icon-zoom-fit-to-content.svg',
    campaignSetup: '/mask-icon-campaign-setup.svg',
    outputMinus: '/decisionTree/icon-minus-output.svg',
    outputPlus: '/decisionTree/output-plus-icon.svg',
    placement: '/placements-icon.svg',
    autoArrangement: '/auto-arrangement-mask-icon.svg',
    commentButton: '/decisionTree/comment-icon.svg',
    commentButtonMasked: '/mask-icon-comments.svg',
    commentButtonSelected: '/decisionTree/selected-comment-icon.svg',
    issueMaskIcon: '/mask-icon-warning-bold.svg',
    addCard: '/decisionTree/add-card-icon.svg',
    addCardMasked: '/mask-icon-add-circle.svg',
    disconnectAllInputs: '/decisionTree/disconnect-input-icon.svg',
    disconnectAllOutputs: '/decisionTree/disconnect-output-icon.svg',
    expandNodes: '/expand-icon.svg',
    showHiddenNodes: '/decisionTree/expand-node-icon.svg',
    sequence: '/decisionTree/sequence-icon.svg',
    addCardShadowed: '/decisionTree/add-circle-shadowed-icon.svg',
    commentsShadowed: '/decisionTree/comments-shadowed-icon.svg',
    fbAdsShadowed: '/decisionTree/fb-ads-shadowed-icon.svg',
    warningShadowed: '/decisionTree/warning-shadowed-icon.svg',
    videoShadowed: '/decisionTree/video-shadowed-icon.svg',
    tearsheet: '/decisionTree/tearsheet-icon.svg',
    tearsheetMasked: '/decisionTree/tearsheet-mask-icon.svg',
    generateData: '/decisionTree/generate-data-new-icon.svg',
    magnifier: '/decisionTree/magnifier-icon.svg',
    audioVariations: '/decisionTree/audio-variations-icon.svg',
    audioVariationsSelected: 'audio-variations-selected-icon.svg',
    brief: '/decisionTree/mask-icon-brief.svg',
    previewIconShadowed: '/decisionTree/preview-icon-shadowed.svg',
    workFlow: {
      importFromConcept: '/decisionTree/workFlow/import-concept-mask-icon.svg',
      createFromScratch: '/decisionTree/workFlow/create-new-mask-icon.svg',
    },
    creativeTypes: {
      display: '/decisionTree/creative_types/image-icon.svg',
      video: '/decisionTree/creative_types/video-icon.svg',
      carousel: '/decisionTree/creative_types/carousel-icon.svg',
    },
  },
  navbar: {
    admin: '/admin-icon.svg',
    analytics: '/analytics-icon.svg',
    campaigns: '/megaphone-icon.svg',
    dashboard: '/dashboard-icon.svg',
    help: '/icon-help.svg',
    libraries: '/libraries-icon.svg',
    settings: '/settings-icon.svg',
    billing: '/admin-icon.svg',
    user: '/user-icon.svg',
    account: '/account-icon.svg',
    accountHovered: '/account-icon-hover.svg',
    suitcase: '/mask-icon-suitcase.svg',
    agency: '/agency-icon.svg',
    notificationCenter: '/notification-center-icon.svg',
    developer: '/developer.svg',
  },
  merlin: {
    layersTable: {
      dynamicIcon: '/merlin/layersTable/mask-icon-dynamic.svg',
      text: '/merlin/layersTable/mask-icon-text.svg',
      shape: '/merlin/layersTable/mask-icon-shape.svg',
      image: '/merlin/layersTable/mask-icon-image.svg',
      precomp: '/merlin/layersTable/mask-icon-precomp.svg',
      video: '/merlin/layersTable/mask-icon-video.svg',
      null: '/merlin/layersTable/mask-icon-null.svg',
      guide: '/merlin/layersTable/mask-icon-guide.svg',
    },
    merlinProjectInfo: {
      connectedTemplate: '/merlin/merlinProjectInfo/connected_template_icon.svg',
      mainComp: '/merlin/merlinProjectInfo/main_comp_icon.svg',
      numOfItems: '/merlin/merlinProjectInfo/num_of_items_icon.svg',
    },
    scripting: {
      baselineShift: '/merlin/scripting/mask-icon-baseline-shift.svg',
      lineBreakArrow: '/merlin/scripting/mask-icon-line-break-arrow.svg',
      textSize: '/merlin/scripting/mask-icon-text-size.svg',
    },
    upload: {
      success: '/merlin/upload/mask-icon-minified-success.svg',
      failure: '/merlin/upload/mask-icon-minified-failed.svg',
    },
  },

  placements: {
    connectExternal: '/CampaignPlacements/connect-external-icon.svg',
    csvSource: '/CampaignPlacements/csv-source-icon.svg',
    dcmSource: '/CampaignPlacements/dcm-source-icon.svg',
    manual: '/CampaignPlacements/manual-icon.svg',
    export: '/CampaignPlacements/export-download-placement.svg',
  },

  campaignTypes: {
    dynamicBanner: '/campaignTypes/dynamic-banners-icon.svg',
    facebook: '/campaignTypes/facebook-video-icon.svg',
    snapchat: '/campaignTypes/snapchat-video-icon.svg',
    linkedIn: '/campaignTypes/linkedIn-icon.svg',
    youtube: '/campaignTypes/youtube-video-icon-v4.svg',
    tiktok: '/campaignTypes/tiktok-video-icon.svg',
    inBannerVideo: '/campaignTypes/in-banner-video-icon.svg',
    interactiveVideo: '/campaignTypes/interactive-video-icon.svg',
    native: '/campaignTypes/native-icon.svg',
    videoAds: '/campaignTypes/static-video-icon.svg',
    dooh: '/campaignTypes/dooh-campaign-icon.svg',
    thirdPartyAdTracking: '/campaignTypes/third-party-ad-tracking-icon.svg',
    audioAd: '/campaignTypes/audio-ad-icon.svg',
    mockSocial: '/campaignTypes/mock.svg',
  },
  campaignWorkflow: {
    autoRepublish: '/campaign-workflow/auto-ads-publish-icon.svg',
  },
  mediaPoster: {
    video: '/icon-social-video.svg',
  },

  analytics: {
    analytics: '/mask-icon-insights.svg',
    calendar: '/analytics/mask-icon-calendar.svg',
    chart_types: {
      line: '/analytics/chart_types/line.svg',
      areaLine: '/analytics/chart_types/areaLine.svg',
      stackedBar: '/analytics/chart_types/stackedBar.svg',
      horizontalBar: '/analytics/chart_types/horizontalBar.svg',
      pieChart: '/analytics/chart_types/pieChart.svg',
    },
  },
  status: {
    success: '/mediaTable/success-icon.svg',
    pending: '/mediaTable/pending-icon.svg',
    failed: '/error-icon.svg',
    canceled: '/mediaTable/canceled-icon.svg',
    googleTranscoding: '/mediaTable/google-transcode_icon.svg',
    paused: '/mediaTable/paused-icon.svg',
  },
  helpCenter: {
    headerBackground: '/Help/help-bg-icon.svg',
    node: '/Help/mask-icon-node.svg',
    play: '/Help/mask-icon-play.svg',
    admin: '/Help/mask-icon-admin.svg',
    analytics: '/Help/mask-icon-analytics.svg',
    campaigns: '/Help/mask-icon-campaigns.svg',
    flightControl: '/Help/mask-icon-flight-control.svg',
    libraries: '/Help/mask-icon-libraries.svg',
    settings: '/Help/mask-icon-settings.svg',
    releaseNotes: '/Help/mask-icon-release-notes.svg',
    releaseNotesSolid: '/Help/mask-icon-release-notes-solid.svg',
    article: '/Help/mask-icon-article.svg',
    folder: '/Help/mask-icon-folder.svg',
    airplane: '/Help/mask-icon-airplane.svg',
    line: '/Help/mask-icon-line.svg',
    library: '/Help/mask-icon-library.svg',
    megaphone: '/Help/mask-icon-megaphone.svg',
  },
  versions: {
    saveVersion: '/campaignVersions/mask-icon-save-version.svg',
    showVersions: '/campaignVersions/mask-icon-show-versions-2.svg',
    active: '/campaignVersions/active.svg',
    activeShadowed: '/campaignVersions/active-version-shadowed-6.svg',
    readonly: '/campaignVersions/readonly.svg',
    draft: '/campaignVersions/draft.svg',
    pendingActivation: '/campaignVersions/pending-activation.svg',
    activateVersion: '/campaignVersions/activate-version-2.svg',
    discardDraft: '/campaignVersions/discard-draft-icon.svg',
    menuIcon: '/campaignVersions/version-menu-button-icon.svg',
    menuIconMasked: '/campaignVersions/mask-icon-version-menu.svg',
    history: '/campaignVersions/mask-icon-history.svg',
  },
  dynamicParams: {
    edit: '/dynamicParams/edit-icon.svg',
    sameAsDefault: '/dynamicParams/same-as-default-icon.svg',
    sameAsDefaultMasked: '/dynamicParams/mask-icon-same-as-default.svg',
    nullValue: '/dynamicParams/null-value-icon.svg',
    nullValueMasked: '/dynamicParams/mask-icon-null-value.svg',
    noMapped: '/dynamicParams/non-mapped-icon.svg',
    dragHandle: '/dynamicParams/drag-handle-icon.svg',
    dynamicSource: '/dynamicParams/mask-icon-dynamic-source-connect.svg',
    generalSourceType: '/dynamicParams/mask-icon-dp-general-source-2.svg',
    timeline: '/dynamicParams/mask-icon-timeline.svg',
    dynamicParamSource: '/dynamicParams/mask-icon-dynamic-param-source.svg',
    noParams: '/dynamicParams/unplugged-icon.svg',
    colorEditor: '/dynamicParams/dp-color-picker-icon.svg',
    valueSource: '/dynamicParams/dp-value-icon.svg',

    collapse: '/dynamicParams/mask-icon-collapse.svg',
    condition: '/dynamicParams/mask-icon-condition.svg',
    openMapping: '/dynamicParams/mask-icon-open-mapping.svg',
    layersTree: '/dynamicParams/mask-icon-layers-tree.svg',
    autoMapping: '/dynamicParams/mask-icon-auto-map.svg',
    autoMappingShadowed: '/dynamicParams/automap-shadowed-icon.svg',

    layerTypeImage: '/dynamicParams/mask-icon-layer-type-image.svg',
    layerTypeVideo: '/dynamicParams/mask-icon-layer-type-video.svg',
    layerTypeText: '/dynamicParams/mask-icon-layer-type-text.svg',
    layerTypeShape: '/dynamicParams/mask-icon-layer-type-shape.svg',
    layerTypeNull: '/dynamicParams/mask-icon-null-value.svg',
    layerTypeDefault: '/dynamicParams/mask-icon-layer-type-image.svg',
    layerTypePrecomp: '/dynamicParams/mask-icon-layer-type-precomp.svg',
    layerTypeClickUrl: '/mask-icon-link.svg',

    paramTypeTextSource: '/dynamicParams/mask-icon-layer-type-text.svg',
    paramTypeStrokeColor: '/dynamicParams/mask-icon-param-type-stroke-color.svg',
    paramTypeFillColor: '/dynamicParams/mask-icon-param-type-fill-color.svg',
    paramTypeFontSize: '/dynamicParams/mask-icon-param-type-font-size.svg',
    paramTypeStrikeThrough: '/dynamicParams/mask-icon-param-type-strike-through.svg',
    paramTypeDefault: '/dynamicParams/mask-icon-param-type-strike-through.svg',

    regenerateVariations: '/mask-icon-regenerate-variations.svg',
    layersTreeIcon: '/dynamicParams/icon-layers-tree.svg',
    timelineIcon: '/dynamicParams/icon-timeline.svg',
  },
  adBuilder: {
    shapeType: {
      rect: '/ad-builder/mask-icon-rect-shape.svg',
      ellipse: '/ad-builder/mask-icon-ellipse-shape.svg',
      star: '/ad-builder/mask-icon-star-shape.svg',
      polygon: '/ad-builder/mask-icon-polygon-shape.svg',
      path: '/ad-builder/mask-icon-pentool.svg',
    },
    cursorModes: {
      select: '/ad-builder/cursor-modes/select-mode-stroked.svg',
      rect: '/ad-builder/cursor-modes/create-rect-mode-stroked.svg',
      ellipse: '/ad-builder/cursor-modes/create-ellipse-mode-stroked.svg',
      polygon: '/ad-builder/cursor-modes/create-polygon-mode-stroked.svg',
      star: '/ad-builder/cursor-modes/create-star-mode-stroked.svg',
      path: '/ad-builder/cursor-modes/create-edit-path-mode-stroked.svg',
      text: '/ad-builder/cursor-modes/create-edit-text-mode-stroked.svg',
      grab: '/ad-builder/cursor-modes/drag-mode.svg',
      pentoolDefault: '/ad-builder/cursor-modes/pentool-default.svg',
      pentoolAddVertex: '/ad-builder/cursor-modes/pentool-add-vertex.svg',
      pentoolClosePath: '/ad-builder/cursor-modes/pentool-close-path.svg',
      pentoolToggleCurve: '/ad-builder/cursor-modes/pentool-toggle-curve.svg',
      pentoolGrab: '/ad-builder/cursor-modes/pentool-grab.svg',
    },
    animationFunctions: {
      linear: '/ad-builder/animation-functions/mask-icon-linear.svg',
      ease: '/ad-builder/animation-functions/mask-icon-ease.svg',
      easeIn: '/ad-builder/animation-functions/mask-icon-ease-in.svg',
      easeOut: '/ad-builder/animation-functions/mask-icon-ease-out.svg',
    },
    align: {
      alignTop: '/ad-builder/alignment/mask-icon-vert-align-top.svg',
      alignVertCenter: '/ad-builder/alignment/mask-icon-vert-align-center.svg',
      alignBottom: '/ad-builder/alignment/mask-icon-vert-align-bottom.svg',
      alignRight: '/ad-builder/alignment/mask-icon-horz-align-right.svg',
      alignHorzCenter: '/ad-builder/alignment/mask-icon-horz-align-center.svg',
      alignLeft: '/ad-builder/alignment/mask-icon-horz-align-left.svg',

      distributeTop: '/ad-builder/alignment/mask-icon-vert-distribution-top.svg',
      distributeVertCenter: '/ad-builder/alignment/mask-icon-vert-distribution-center.svg',
      distributeBottom: '/ad-builder/alignment/mask-icon-vert-distribution-bottom.svg',
      distributeRight: '/ad-builder/alignment/mask-icon-horz-distribution-right.svg',
      distributeHorzCenter: '/ad-builder/alignment/mask-icon-horz-distribution-center.svg',
      distributeLeft: '/ad-builder/alignment/mask-icon-horz-distribution-left.svg',
    },
    keyframesActions: {
      splitDimensions: '/ad-builder/keyframes-graph-actions/mask-icon-split-dimensions.svg',
      ease: '/ad-builder/keyframes-graph-actions/mask-icon-ease.svg',
      easeIn: '/ad-builder/keyframes-graph-actions/mask-icon-ease-in.svg',
      easeOut: '/ad-builder/keyframes-graph-actions/mask-icon-ease-out.svg',
      linear: '/ad-builder/keyframes-graph-actions/mask-icon-linear.svg',
      hold: '/ad-builder/keyframes-graph-actions/mask-icon-hold.svg',
      custom: '/ad-builder/keyframes-graph-actions/mask-icon-custom.svg',
    },
    emptyAssets: {
      [MovieLayerType.Text]: '/ad-builder/text-icon.svg',
      [MovieLayerType.Image]: '/ad-builder/image-icon.svg',
      [MovieLayerType.Video]: '/ad-builder/camera-icon.svg',
    },
    selectModeWhite: '/ad-builder/select-mode-white.svg',
    grabModeWhite: '/ad-builder/grab-mode-white.svg',
    selectMode: '/ad-builder/mask-icon-select-mode.svg',
    object3D: '/ad-builder/mask-icon-3d.svg',
    object3DHeader: '/ad-builder/mask-icon-3d-header.svg',
    keyframeOutline: '/ad-builder/mask-icon-keyframe-outline.svg',
    keyframeFill: '/ad-builder/mask-icon-keyframe-fill.svg',
    keyframeGraph: '/ad-builder/mask-icon-keyframes-graph.svg',
    inputResize: '/ad-builder/resize-ew-icon.svg',
    undo: '/ad-builder/undo-icon.svg',
    grid: '/ad-builder/grid-icon.svg',
    emptyState: '/ad-builder/empty-state-icon.svg',
    inverse: '/ad-builder/mask-icon-inverse.svg',
    motionBlur: '/ad-builder/mask-icon-motion-blur.svg',
  },
  htmlEditor: {
    bold: '/html-editor/mask-icon-bold.svg',
    italic: '/html-editor/mask-icon-italic.svg',
    color: '/html-editor/mask-icon-text-color.svg',
    allCaps: '/html-editor/mask-icon-all-caps.svg',
    letterSpacing: '/html-editor/mask-icon-letter-spacing.svg',
    textWrap: '/html-editor/mask-icon-line-break.svg',
    removeStyles: '/html-editor/mask-icon-remove-styles.svg',
    alignLeft: '/html-editor/mask-icon-align-left.svg',
    alignCenter: '/html-editor/mask-icon-align-center.svg',
    alignRight: '/html-editor/mask-icon-align-right.svg',
    lightTheme: '/html-editor/mask-icon-light-theme.svg',
    darkTheme: '/html-editor/mask-icon-dark-theme.svg',
    scaleUp: '/html-editor/mask-icon-scale-up.svg',
    scaleDown: '/html-editor/mask-icon-scale-down.svg',
    fontFamily: '/html-editor/mask-icon-font-family.svg',
    convertToSimpleText: '/html-editor/convert-to-simple-text-icon.svg',
    convertToComplexText: '/html-editor/mask-icon-complex-text-convert.svg',
    strikeThrough: '/html-editor/mask-icon-strike-through.svg',
    underline: '/html-editor/mask-icon-underline.svg',
    lineHeight: '/html-editor/mask-icon-line-height.svg',
    verticalAlignTop: '/html-editor/mask-icon-vertical-align-top.svg',
    verticalAlignCenter: '/html-editor/mask-icon-vertical-align-middle.svg',
    verticalAlignBottom: '/html-editor/mask-icon-vertical-align-bottom.svg',
    minFontSize: '/html-editor/mask-icon-min-font-size.svg',
    shiftX: '/html-editor/mask-icon-text-shift-x.svg',
    shiftY: '/html-editor/mask-icon-shift-y.svg',
  },

  tearsheet: {
    videoPlayer: '/tearsheet/video-player-icon-2.svg',
    videoStrip: '/tearsheet/video-strip-icon-2.svg',
    videoPlayerMasked: '/tearsheet/video-player-masked-icon.svg',
    videoStripMasked: '/tearsheet/video-strip-masked-icon.svg',
    lock: '/tearsheet/lock.svg',
    skippablePreview: '/tearsheet/vast-icon.svg',
  },

  facebook: {
    adsMenu: '/Facebook/ads-icon.svg',
    planned: '/Facebook/planned-icon.svg',
    published: '/Facebook/publish-icon.svg',
    share: '/Facebook/fb-share-icon.svg',
    like: '/Facebook/fb-like-icon.svg',
    comment: '/Facebook/fb-comments-icon.svg',
    settings: '/Facebook/fb-settings-icon.svg',
    threeDots: '/Facebook/fb-three-dots-icon.svg',
    publishAds: '/Facebook/publish-ext-ads-icon.svg',
    generateAds: '/Facebook/generate-ads-icon.svg',
    triangle: '/Facebook/icon-fb-triangle.svg',
  },

  instagram: {
    logo: '/Facebook/Instagram/Instagram_logo.svg',
    chat: '/Facebook/Instagram/chat-icon.svg',
    heart: '/Facebook/Instagram/heart-icon.svg',
    message: '/Facebook/Instagram/message-icon.svg',
    save: '/Facebook/Instagram/save-icon.svg',
    more: '/Facebook/Instagram/more-dots-icon.svg',
    fromFacebookPage: '/Facebook/Instagram/from-facebook-page.svg',
  },

  socialLogos: {
    [FacebookPlacementType.Facebook]: '/Facebook/facebook-logo-icon.svg',
    [FacebookPlacementType.Instagram]: '/Facebook/instagram-logo-icon.svg',
    [FacebookPlacementType.Messenger]: '/Facebook/messenger-logo-icon.svg',
    [FacebookPlacementType.AudienceNetwork]: '/Facebook/audience-network-logo-icon.svg',
  },

  gifs: {
    renderingProcess: '/gifs/rendering-process-gif.gif',
    pendingAds: '/gifs/publishing-ads.gif',
  },

  identity: {
    ip: '/identity/mask-icon-ip.svg',
    intentIQ: '/identity/intent-iq-icon.png',
    userId: '/identity/mask-icon-user-2.svg',
    houseHold: '/identity/mask-icon-house-hold.svg',
    deviceId: '/identity/mask-icon-deviceid.svg',
    theTradeDesk: '/identity/mas-icon-the-trade-desk.svg',
    neustar: '/identity/mask-icon-neustar.svg',
    liveRamp: '/identity/mask-icon-liveramp.svg',
    cookie1p: '/identity/mask-icon-cookie1p.svg',
    cookie3p: '/identity/mask-icon-cookie3p.svg',
    adImpression: '/identity/mask-icon-impression.svg',
    adClick: '/identity/mask-icon-click.svg',
    adEngage: '/identity/mask-icon-click.svg',
    sessionConversion: '/identity/conversion-icon.svg',
    webSessionPageView: '/identity/mask-icon-view-page.svg',
    webSessionSearch: '/identity/mask-icon-search.svg',
    webSessionCategory: '/identity/mask-icon-category.svg',
    webSessionViewProduct: '/identity/mask-icon-view-product.svg',
    webSessionAddToCart: '/identity/mask-icon-add-to-cart-3.svg',
    webSessionCheckout: '/identity/mask-icon-checkout-2.svg',
    webSessionPurchase: '/identity/mask-icon-purchase-2.svg',
  },

  tablePlaceHolders: {
    carousel: '/carousel-placeholder-icon.svg',
    image: '/image-placeholder-icon.svg',
    video: '/video-placeholder-icon.svg',
    sound: '/sound-placeholder-icon.svg',
  },

  comments: {
    replyComment: '/comments/reply-comment-icon.svg',
    wideV: '/comments/comment-v-icon.svg',
    pinNormal: '/comments/comment-pin-normal-icon.svg',
    pinSelected: '/comments/comment-pin-selected-icon.svg',
    pinSolved: '/comments/comment-pin-solved-icon.svg',
    largeNumber: '/comments/large-number-regular.svg',
    largeNumberSelected: '/comments/large-number-selected.svg',
    largeNumberSolved: '/comments/large-number-solved.svg',
    groupedComments: '/comments/grouped-comments.svg',
    groupedCommentsSelected: '/comments/grouped-comments-selected.svg',

    commentNormal: '/comments/comment-normal.svg',
    commentNormalHover: '/comments/comment-normal-hover.svg',
    commentShadowed: '/comments/comment-shadowed-icon.svg',
    selectedHover: '/comments/comment-selected-hover.svg',
    resolved: '/comments/resolved-comment.svg',
    resolvedHover: '/comments/resolved-comment-hover.svg',
  },
} as const;

const iconsObj = createIconsObj(iconsObjData);
export default iconsObj;
